<template>
  <v-tooltip location="top">
    <template #activator="{ props }">
      <span
        v-bind="props"
        :class="['inline-block w-2 h-5 rounded-full mr-2', borderMap[status], bgMap[status]]"
      ></span>
    </template>
    <span>{{ labelMap[status] }}</span>
  </v-tooltip>
</template>

<script setup lang="ts">
defineProps<{
  status: 'vinculada' | 'em_edicao' | 'nao_vinculada'
}>()

const borderMap: Record<string, string> = {
  vinculada: 'border border-green-500',
  em_edicao: 'border border-yellow-400',
  nao_vinculada: 'border border-red-500'
}

const bgMap: Record<string, string> = {
  vinculada: 'bg-green-100',
  em_edicao: 'bg-yellow-100',
  nao_vinculada: 'bg-red-100'
}

const labelMap: Record<string, string> = {
  vinculada: 'Vinculada',
  em_edicao: 'Em edição',
  nao_vinculada: 'Não vinculada'
}
</script>
